<template>
    <VDialog
      :value="visible"
      scrollable
      max-width="425px"
      :fullscreen="$vuetify.breakpoint.xs"
      @click:outside="$emit('close')"
    >
      <VCard
        tile
        :class="showSearchResultDialogLoading ? 'h-100' : 'overflow-y-none'"
      >
        <VCardTitle class="justify-space-between">
          <h6 class="heading-6">
            {{ $t('bookingForm.confirmYourQuote') }}
          </h6>
          <VBtn
            class="grey-lighten-4 box-shadow-elevation-6"
            icon
            data-test="close-search-result-dialog"
            @click.stop="$emit('close')"
          >
            <VIcon color="textPrimary">
              mdi-close
            </VIcon>
          </VBtn>
        </VCardTitle>
        <template v-if="!showSearchResultDialogLoading"> 
        <SBookingSummary :selectedRides="selectedRides" />
        <VCardActions class="pb-4">
          <div class="px-1 w-50">
            <VBtn
              class="w-100"
              outlined
              data-test="cancel-booking-button"
              @click.stop="$emit('close')"
            >
              <span class="button">
                {{ $t('general.cancel') }}
              </span>
            </VBtn>
          </div>
          <div class="px-1 w-50">
            <VBtn
              class="w-100 text-decoration-none"
              color="brandingPrimary"
              data-test="confirmBooking"
              dark
              @click="$emit('toCheckoutPage')"
            >
              <span class="button-icon mr-2">
                <VIcon
                  size="large"
                >
                  mdi-check
                </VIcon>
              </span>
              <span class="button">
                {{ $t('general.confirm') }}
              </span>
            </VBtn>
          </div>
        </VCardActions>
        </template>
        <SSearchResultDialogSkeletonLoader v-else />
      </VCard>
    </VDialog>
</template>

<script lang="ts">
export default {
  name: 'SSearchResultDialog',
};
</script>

<script setup lang="ts">
import SBookingSummary from '@slg/web-customer-shared/src/components/common/bookingSummary/SBookingSummary.vue';
import SSearchResultDialogSkeletonLoader from './SSearchResultDialogSkeletonLoader.vue';

defineProps({
  visible: {
    type: Boolean,
    required: true,
    default: false,
  },
  selectedRides: {
    type: Array,
    default: () => [],
  },
  showSearchResultDialogLoading: {
    type: Boolean,
    required: true,
    default: false,
  },
});
</script>

<style scoped lang="scss">
</style>
